import axios from "axios";

import { useState, useEffect } from "react";

import { Link, useNavigate, useSearchParams } from "react-router-dom";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import SearchIcon from "@mui/icons-material/Search";
import InputLabel from "@mui/material/InputLabel";
import FilledInput from "@mui/material/FilledInput";
import IconButton from "@mui/material/IconButton";

// Icons
import {
  FaRegUser,
  FaMagnifyingGlass,
  FaBasketShopping,
} from "react-icons/fa6";

import { RiLuggageDepositFill } from "react-icons/ri";
import { LuLuggage, LuUser } from "react-icons/lu";

// Image
import tvc_Logo from "../photos/tvc_logo.png";

// Note: This is sticky

import Banner from "./Banner";

import BorderColorIcon from "@mui/icons-material/BorderColor";

export default function Header() {
  const baseURL = process.env.REACT_APP_BASE_URL;
  let navigate = useNavigate();
  let [cartNumber, setCartNumber] = useState(0);
  let [navCat, setNavCat] = useState([
    "Film",
    "Disposable Cameras",
    "Batteries",
    "Accessories",
    "Books",
  ]);

  const [user, setUser] = useState({ user_name: "" });

  useEffect(() => {
    // Function to fetch cart data from the database
    const fetchCartItems = async () => {
      try {
        const response = await fetch(`${baseURL}/cart-view`, {
          method: "GET",
          credentials: "include",
        });

        if (!response.ok) {
          throw new Error("Failed to fetch cart data");
        }

        const data = await response.json();
        const totalQuantity = data.cartItems.reduce(
          (sum, item) => sum + item.prod_quan,
          0
        );
        setCartNumber(totalQuantity); // Set the total quantity of all items in the cart
      } catch (error) {
        console.error("Error fetching cart items:", error);
      }
    };

    // Trigger the fetch on component load
    fetchCartItems();

    // You can also add a dependency array if you want to refetch when certain props or state change
  }, []);

  useEffect(() => {
    axios
      .get(`${baseURL}/decode-token`, { withCredentials: true }) // Request user_name
      .then((response) => {
        setUser({ user_name: response.data.user_name });
      })
      .catch((error) => {});
  }, [navigate]);

  function changeLocation(placeToGo) {
    navigate(placeToGo, { replace: true });
    window.location.reload();
  }

  const [searchParams, setSearchParams] = useSearchParams();
  const [isChecked, setIsChecked] = useState(false);

  let [searchValue, setSearchValue] = useState(searchParams.get("search"));

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const handleMouseUpPassword = (event) => {
    event.preventDefault();
  };

  const handleChange = (event) => {
    // Toggle the checkbox state
    const newIsChecked = !isChecked;
    setIsChecked(newIsChecked); // Update checkbox state

    // Update the search parameters based on the checkbox state
    if (newIsChecked) {
      // If the checkbox is now checked, add the new sort-by value
      searchParams.set("sort-by", event.target.value);
    } else {
      // If the checkbox is now unchecked, remove the sort-by parameter
      searchParams.delete("sort-by");
    }

    // Update the URL
    setSearchParams(searchParams);
    props.setParams({ sortBy: event.target.value });
  };

  return (
    <header className="App-header">
      <Banner />
      <nav className="navbar">
        <ul className="navbar_list">
          <li>
            <Link to={`/`} style={{ textDecoration: "none" }}>
              {" "}
              <img
                src={tvc_Logo}
                alt="The Vintage Collective"
                style={{ width: "200px" }}
              />
            </Link>
          </li>
          <li>
            <ul className="navbar_list_right">
              <li>
                <FormControl sx={{ width: "100%" }} variant="outlined">
                  <OutlinedInput
                    id="filled-adornment-password"
                    type={"text"}
                    value={searchValue}
                    onChange={(event) => {
                      setSearchValue(event.target.value);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        searchValue != ""
                          ? changeLocation(`/catalogue?search=${searchValue}`)
                          : "";
                      }
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          onClick={(event) => {
                            searchValue != ""
                              ? changeLocation(
                                  `/catalogue?search=${searchValue}`
                                )
                              : "";
                          }}
                        >
                          {" "}
                          <SearchIcon
                            onMouseDown={handleMouseDownPassword}
                            onMouseUp={handleMouseUpPassword}
                            edge="end"
                          />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </li>

              <Link to="/cart">
                <li>
                  <div className="cart_icon">
                    <LuLuggage sx={{ fontSize: "xxx-large" }} />
                  </div>

                  <div className="number_tag">{cartNumber}</div>
                </li>
              </Link>

              <li>
                <Link
                  to={"/auth/login"}
                  style={{ textDecoration: "none", display: "flex" }}
                >
                  <LuUser sx={{ fontSize: "xxx-large" }} />
                  <span style={{ fontSize: "1rem" }}>
                    {" "}
                    {user?.user_name
                      ? "Hello " + user.user_name + "!"
                      : "Hello Guest!"}
                  </span>
                </Link>
              </li>
            </ul>
          </li>
        </ul>

        <ul className="navbar_list_left">
          <Link to="/">
            <li className="navbar_item">Home</li>
          </Link>

          {navCat.map((cat, index) => (
            <Link
              to={`/catalogue?keyword=${cat}`}
              onClick={() => changeLocation(`/catalogue?keyword=${cat}`)}
            >
              <li className="navbar_item">{cat}</li>
            </Link>
          ))}

          <li
            className="navbar_item"
            onClick={() => changeLocation(`/contact`)}
          >
            Contact Us
          </li>
        </ul>
      </nav>
    </header>
  );
}
